export const OAUTH_STATE_KEY = "loa_oauth_state";
export const BASE_DOMAIN = (import.meta.env.VITE_BASE_DOMAIN as string) ?? "loa.localhost";
export const TENANT_HEADER = (import.meta.env.VITE_TENANT_HEADER as string) ?? "X-Tenant";
export const ACTIVE_TENANT_COOKIE = "loa_active_tenant";
export const SAFE_FALLBACK_ROUTE = "/dashboard";
export const LOGIN_ROUTE = "/auth/login";
export const LOGOUT_ROUTE = "/auth/logout";
export const ERROR_ROUTE = "/auth/error";
export const SUCCESS_ROUTE = "/auth/success";
